import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
/*
 * @Author: 曹小丽
 * @Description:
 * @Date: 2022-04-13 10:17:05
 * @LastEditTime: 2022-05-13 16:38:29
 * @FilePath: \insurforce-backstage-platform-side\src\views\claim\demageManage\utils.js
 */
const columns = [{
  slots: {
    title: '序号'
  },
  dataIndex: 'index',
  scopedSlots: {
    customRender: 'index'
  },
  width: 80,
  align: 'center'
}, {
  slots: {
    title: '文件名称'
  },
  dataIndex: 'name',
  key: 'name',
  align: 'center'
}, {
  slots: {
    title: '文件格式'
  },
  dataIndex: 'format',
  key: 'format',
  align: 'center',
  scopedSlots: {
    customRender: 'format'
  }
}, {
  slots: {
    title: '排序'
  },
  dataIndex: 'sort',
  key: 'sort',
  align: 'center'
}, {
  slots: {
    title: '状态'
  },
  dataIndex: 'status',
  key: 'status',
  align: 'center',
  scopedSlots: {
    customRender: 'status'
  }
}, {
  slots: {
    title: '更新时间'
  },
  dataIndex: 'updateAt',
  key: 'updateAt',
  align: 'center'
}, {
  slots: {
    title: '操作'
  },
  dataIndex: 'operation',
  key: 'operation',
  align: 'center',
  width: 200,
  scopedSlots: {
    customRender: 'operation'
  }
}];
const pagination = {
  showSizeChanger: true,
  showQuickJumper: true,
  total: 0,
  pageSize: 10,
  // 每页条数
  page: 1,
  current: 1,
  showTotal: total => {
    return `共 ${total} 条`;
  },
  onShowSizeChange: (current, size) => {
    pagination.pageSize = size;
  }
};
const statusSelectList = [{
  key: '',
  name: '全部'
}, {
  key: 0,
  name: '已禁用'
}, {
  key: 1,
  name: '已启用'
}];

//plainOptions数据不需改动,是对的       'mov'(先隐藏)
const plainOptions = ['xlsx', 'xls', 'docx', 'doc', 'jpg', 'pdf', 'jpeg', 'png', 'rm', 'mp4', 'rmvb', 'avi'];
const ADD_RULES = {
  name: [{
    required: true,
    message: '请输入文件名称',
    trigger: 'blur'
  }, {
    message: '1-50字符',
    max: 50,
    min: 1
  }],
  sort: [{
    required: true,
    message: '请输入排序数',
    trigger: 'blur'
  }],
  // templateDesc: [
  //   {required: true, message: '请输入模板说明', trigger: 'blur'},
  //   {message: '1-500字符', max: 500, min: 1}
  // ],
  format: [{
    type: 'array',
    required: true,
    message: '请选择文件格式',
    trigger: 'change'
  }]
  // fileList: [{type: 'array', required: true, message: '请选择文件模板', trigger: 'change'}]
};
const getBase64 = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
};

// 是否为图片
const isImage = filePath => {
  const types = ['png', 'jpg', 'jpeg'];
  // 文件后缀
  const type = fileExtension(filePath);
  return types.indexOf(type) !== -1;
};
// 是否为视频
const isVideo = filePath => {
  const types = ['avi', 'mov', 'rm', 'mp4', 'rmvb'];
  const type = fileExtension(filePath);
  return types.indexOf(type) !== -1;
};
// 是否为PDF
const isPDF = filePath => {
  const types = ['pdf'];
  const type = fileExtension(filePath);
  return types.indexOf(type) !== -1;
};

// 是否为excel
const isExcel = filePath => {
  const types = ['xlsx', 'xls'];
  const type = fileExtension(filePath);
  return types.indexOf(type) !== -1;
};

// 是否为word
const isWord = filePath => {
  const types = ['docx', 'doc'];
  const type = fileExtension(filePath);
  return types.indexOf(type) !== -1;
};
// 获取文件后缀类型
const fileExtension = filePath => {
  // 获取最后一个.的位置
  const index = filePath.lastIndexOf('.');
  // 获取后缀
  const type = filePath.substr(index + 1);
  // 返回类型
  return type.toLowerCase();
};

// 删除对象中某个属性
const deleteValueOfObject = (obj, deleteValue) => {
  obj = Object.entries(obj);
  obj.map((item, index, arr) => {
    if (item[0] === deleteValue) {
      arr.splice(index, 1);
    }
  });
  return Object.fromEntries(obj);
};
export { columns, pagination, statusSelectList, plainOptions, ADD_RULES, getBase64, isImage, isVideo, isPDF, isExcel, isWord, deleteValueOfObject };